import { useMutation } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";

interface Data {
    projectId: string;
}
interface Options {
    onSuccess?: (data: Data) => void;
}

export function useCreateProjectMutation(chatId: string, options?: Options) {
    return useMutation({
        mutationFn: async () => {
            const res = await apiClient.createProject({
                body: {
                    createProjectChatId: chatId,
                },
            });
            if (res.status !== 200) {
                throw new Error("Failed to launch project");
            }
            return {
                projectId: res.body.id,
            };
        },
        onSuccess: options?.onSuccess,
    });
}
